package com.essntl.features.message.domain.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.message.domain.useCase")
class MessageUseCaseModule